import { difference } from "./difference"

export const symmetricDifference = <T>(array1: T[], array2: T[]): T[] => {
  return [...difference(array1, array2), ...difference(array2, array1)]
}
